import React, { useEffect } from 'react';
import '../styles/CaseStudyDetail.css';
import { handleLinkClick } from '../utils/deviceUtils';
import images from '../assets/index';

const CaseStudy1 = () => {

    useEffect(() => {
        document.title = "Modernizing Compliance & Reporting with Data at Scale | Datamatics Consulting";
    }, []);
    return (
        <div className="cs-page">

            {/* Hero */}
            <section className="cs-hero">
                <div className="cs-hero-overlay">
                    <span className="cs-sector-badge">Banking Sector</span>
                    <h1>Modernizing Compliance & Reporting with Data at Scale</h1>
                    <p>A leading bank transformed legacy reporting into a modern data foundation — cutting costs, improving compliance, and unlocking real-time insights.</p>
                </div>
            </section>

            {/* Body */}
            <section className="cs-body container">

                <div className="cs-section">
                    <div className="cs-label">Challenge</div>
                    <div className="cs-content">
                        <p>A leading bank was buried under 400+ legacy SAS reports. Compliance deadlines were consistently at risk, manual reconciliations consumed entire teams, and executives lacked timely insights to steer strategy. The result: slower decision-making, higher operating costs, and missed opportunities to respond quickly to regulatory demands and market shifts.</p>
                    </div>
                </div>
                <div className="cs-divider" />
                <div className="cs-section">
                    <div className="cs-label">Our Approach & Solution</div>
                    <div className="cs-content">
                        <p>Datamatics partnered with the bank to rethink reporting from the ground up. We worked hand-in-hand with business and compliance teams to design a modern data foundation that prioritized agility, consistency, and trust. Instead of patching old systems, the approach was to consolidate, simplify, and standardize reporting to free leadership from operational drag.</p>
                        <p>We deployed an <strong>Enterprise Data Warehouse</strong> as the single source of truth and introduced <strong>Master Data Management (MDM)</strong> to eliminate duplication and improve accuracy. For reporting, we transitioned from SAS to <strong>Tableau</strong>, creating interactive dashboards that delivered near real-time insights. To support speed and scale, we integrated <strong>Hazelcast's in-memory data grid</strong>, enabling high-performance data access and faster reconciliation.</p>
                    </div>
                </div>
            </section>

            {/* Results */}
            <section className="cs-results">
                <h2>Results</h2>
                <div className="cs-results-grid">
                    <div className="cs-stat">
                        <span className="cs-stat-number">35%</span>
                        <p>Faster reporting cycles, freeing leaders to act on insights sooner</p>
                    </div>
                    <div className="cs-stat">
                        <span className="cs-stat-number">$1.2M</span>
                        <p>In annual operating savings by reducing reliance on legacy infrastructure.</p>
                    </div>
                    <div className="cs-stat">
                        <span className="cs-stat-number">45%</span>
                        <p>Fewer manual reconciliations, enabling teams to focus on value creation.</p>
                    </div>
                    <div className="cs-stat">
                        <span className="cs-stat-number">100%</span>
                        <p>Compliance with NDMO standards, eliminating regulatory risk.</p>
                    </div>
                </div>
            </section>

            {/* Other Case Studies */}
            <section className="cs-related container">
                <div className="cs-related-header">
                    <div className="purple-line-cs"></div>
                    <span className="cs-related-label">Case Studies</span>
                </div>
                <div className="cs-cards-grid">
                    {[
                        { title: "Building a Trusted Data Foundation for Financial Services", image: images.newcase1, to: "/case-studies/financial-services" },
                        { title: "Unified Data for Smarter Insurance Decisions", image: images.newcase3, to: "/case-studies/insurance" },
                        { title: "A Single Customer View for Better Airline Experiences", image: images.newcase4, to: "/case-studies/airline" },
                    ].map((s, i) => (
                        <div key={i} className="cs-card" onClick={() => handleLinkClick(s.to)} style={{ cursor: 'pointer' }}>
                            <div className="cs-card-img-wrap">
                                <img src={s.image} alt={s.title} />
                            </div>
                            <h3>{s.title}</h3>
                            <a href={s.to} className="cs-read-more" onClick={(e) => { e.preventDefault(); handleLinkClick(s.to); }}>Read More →</a>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default CaseStudy1;